export default "__VITE_ASSET__CNt2$FT9__"